import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Flex } from '@components/Layout'
import { Button } from 'antd'

import AppModal from '.'
import { AppButton } from '@components/AppComponents'

type Props = {
  onCancel?: () => void
  modalParams: {
    saveLabel: string
    confirmMessage: string
    onSave: () => void
    discardChange: () => void
    onCancel?: () => void
  }
}
const WarningExitWithoutSave = ({
  onCancel = () => {},
  modalParams,
}: Props) => {
  const { onSave, discardChange } = modalParams

  const handleOnOkClick = () => {
    onCancel()
    onSave?.()
  }
  const handleDiscardChange = () => {
    onCancel()
    discardChange?.()
  }

  const handleCancel = () => {
    onCancel()
    modalParams.onCancel?.()
  }

  return (
    <AppModal
      title={''}
      open={true}
      width={600}
      className="custom-popup-confirm"
      footer={
        <>
          <AppButton color="blue" onClick={handleOnOkClick}>
            {modalParams.saveLabel}
          </AppButton>
          <AppButton color="yellow" onClick={handleDiscardChange}>
            Discard changes
          </AppButton>
          <AppButton color="red" onClick={handleCancel}>
            Cancel
          </AppButton>
        </>
      }
    >
      <div className="custom-content-popup-confirm flex items-center flex-col">
        <ExclamationCircleOutlined style={{ color: 'orange', fontSize: 55 }} />
        <div className="modal-confirm-message mt-5">
          {modalParams.confirmMessage}
        </div>
      </div>
    </AppModal>
  )
}

export default WarningExitWithoutSave
